<template>
  <div class="Top">
    <v-card mb-5 class="pa-3 shadow-none" flat>
      <v-img :src="require('@/assets/top-banner.jpg')" class="white--text align-end">
      <v-card-title class="headline"></v-card-title>
      </v-img>
      <v-card-title  gray>愛犬家エンジニアのmotoikeと申します。<br>都内でフロントエンドエンジニアをしています。</v-card-title>
    </v-card>
    <!-- <v-card class="mt-4 mb-4 pa-3 shadow-none"> -->
      <v-responsive min-height="20vh"></v-responsive>
      <div id="portfolio">
      <h2 mt-5 style="text-align:center">製作物</h2>
      </div>
      <v-container>
        <v-layout row wrap mt-8>
            <v-flex xs6 v-for="(item,i) in items" :key="i" transition="fade-transition">
                <v-card class="ml-4 mt-4 mb-4 mr-4">
                  <v-img :src="item.src" class="white--text align-end">
                  </v-img>
                    <!-- <v-card-text><img :src="item" width="100%" alt=""></v-card-text> -->
                  <v-card-title>{{item.name}}</v-card-title>
                  <v-card-subtitle>{{item.description}}</v-card-subtitle>
                </v-card>
            </v-flex>
        </v-layout>
      </v-container>
      <v-responsive min-height="20vh"></v-responsive>
      <div class="profile" id="profile">
      <div class="profile__top"><h2></h2></div>
      <div ml-4 pl-4 class="profile__main">
        <div class="profile__main__img"><img src="@/assets/profile.jpeg" alt="image01" id="profile-img"></div>
        <div class="profile__main__content">
          <ul>
            <li>motoike</li>
            <li><span class="under">フロントエンドエンジニア</span></li>
            <li><span class="under"></span></li>
            <li><span class="under"></span></li>
            <li><span class="under"></span></li>
          </ul>
        </div>
      </div>
      </div>
      <h2 mt-3 style="text-align:center"></h2>
      <v-container>
        <v-layout row wrap mt-8>
            <v-flex xs2 v-for="(skill,i) in skills" :key="i">
              <v-card class="ml-4 mt-4 mb-4 mr-4" flat height="100%" style="align-items: center; display: flex;">
                  <v-img :src="skill.src" width="" class="white--text align-end" >
                  </v-img>
                    <!-- <v-card-text><img :src="item" width="100%" alt=""></v-card-text> -->
                    </v-card>
            </v-flex>
        </v-layout>
      </v-container>
  <!-- </v-card> -->
  </div>
  <!-- <img src="@/assets/furima.jpeg" width="100%" alt=""> -->
</template>
<script>
export default {
  data () {
    return{
        drawer: null,
        isActive: false,
        items:[
           {name: 'my life Cross Search', description: '外部APIを用いた検索アプリケーションです。', src: require('@/assets/my-life-cross-search.png')},
           {name: 'Mydogcareapp', description: '愛犬の体調管理、情報共有を目的としたアプリケーションです。', src: require('@/assets/mydogcareapp.png')},
           {name: 'FURIMA', description: 'フリマアプリのクローンサイトです。', src: require('@/assets/furima.jpeg')},
        ],
        skills:[
           {name: 'HTML5', description: 'HTML5', src: require('@/assets/skills/html-5.svg')},
           {name: 'CSS3', description: 'CSS3', src: require('@/assets/skills/css-3.svg')},
           {name: 'javascript', description: 'javascript', src: require('@/assets/skills/javascript.svg')},
           {name: 'php', description: 'php', src: require('@/assets/skills/php.svg')},
           {name: 'laravel', description: 'laravel', src: require('@/assets/skills/laravel.svg')},
           {name: 'vue.js', description: 'vue.js', src: require('@/assets/skills/vue.svg')},
           {name: 'mysql', description: 'mysql', src: require('@/assets/skills/mysql.svg')},
           {name: 'postgresql', description: 'postgresql', src: require('@/assets/skills/postgresql.svg')},
           {name: 'github', description: 'github', src: require('@/assets/skills/github-octocat.svg')},
           {name: 'docker', description: 'docker', src: require('@/assets/skills/docker-icon.svg')},
        ],
    }
  }
}
</script>
<style scoped>
#profile-img { 
  border-radius: 50%;
  filter: drop-shadow(10px 10px 10px rgba(0,0,0,0.6));
  margin-left: 100px;
}

.profile {
  /* height: 800px; */
}

.profile__main {
  display: flex;
}

.profile__main__content {
  margin-left: 100px;
  margin-top: 100px;
  font-size: 15px;
}

.contact {
  height: 800px;
  /* background-image: url(img/bg01.jpg); */
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
}

.profile__main__content ul {
  font-size: 20px;
}

.profile__main__content ul li {
  line-height: 1.5;
  padding: 0.5em 0;
  list-style-type: none!important;
}
</style>